import React from 'react';

export default class Header extends React.Component {

    constructor(props) {
      super(props);
      this.state = {
        data : null
      };
    }


	render() {
		return (
			<header class="header">
				<strong class={'logo ' + this.props.logo}><a title={this.props.title} href={this.props.url} target="_blank">{this.props.title}</a></strong>
				{this.props.step == 'select' && this.props.showTotal &&
					<div>
						<h1>Какие еще магазины/бренды Вы бы хотели видеть в нашем ТРЦ?</h1>
						<p><a href="" onClick={e => this.props.changeStep('selected',e)}>Выбрано</a> по всем категориям: {this.props.selectedTotal}</p>
					</div>
				}
				{this.props.step == 'selected' &&
					<div>
						<h1>Выбранные магазины</h1>
					</div>
				}
				{this.props.step == 'form' &&
					<div>
						<h1>Отправка заявки</h1>
						<h2>Оставьте, пожалуйста, свои контактные данные, чтобы мы смогли проинформировать Вас о появлении выбранных Вами брендов в нашем ТРЦ</h2>
					</div>
				}
				{this.props.step == 'confirm' &&
					<div>
						<h1>Подтверждение</h1>
						<h2>На номер телефона {this.props.form.phone} был отправлен код</h2>
					</div>
				}
				{this.props.step == 'success' &&
					<div>
						<h1>Спасибо!</h1>
						<h2>Мы получили Вашу анкету.</h2>
					</div>
				}
			</header>
		);
	}

}